export default __webpack_public_path__ + "static/media/sales_module.a6c0c499.svg";